import { CollapseItem } from 'element-ui';
const isAnyPartOfElementInViewport = el => {
	const rect = el.getBoundingClientRect();
	const windowHeight = window.innerHeight || document.documentElement.clientHeight;
	const windowWidth = window.innerWidth || document.documentElement.clientWidth;
	const vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
	const horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
	return vertInView && horInView;
};
export default {
	data() {
		return {
			initOpened: false,
			initOpenedMatters: true
		};
	},
	extends: CollapseItem,
	props: {
		ariaControls: {
			required: false
		},
		moduleId: {
			required: false
		},
		gaCategory: {
			required: false
		},
		gaAction: {
			required: false
		},
		gaLabel: {
			required: false
		},
		gtmEvent: {
			required: false
		},
		initOpenedProp: {
			required: false,
			default: false
		},
		header: {
			type: String
		},
		anyAccordionItemClicked: {}
	},
	methods: {
		onAccordionItemClick() {
			this.$emit('on-accordion-toggle');
		}
	},
	watch: {
		isActive(val) {
			if (val) {
				window.requestAnimationFrame(() => {
					setTimeout(() => {
						if (this.$refs.headerButton && !isAnyPartOfElementInViewport(this.$refs.headerButton)) {
							this.$refs.headerButton.scrollIntoView();
						}
					});
				});
			}
		}
	},
	computed: {
		isActive() {
			return this.collapse.activeNames.indexOf(this.name) > -1 || (this.initOpened && !this.anyAccordionItemClicked);
		}
	},
	created() {
		this.initOpened = this.initOpenedProp;
		this.$nextTick(() => {
			if (this.initOpened && this.collapse.activeNames.indexOf(this.name) === -1) {
				this.collapse.activeNames.push(this.name);
			}
		});
	}
};
